import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { CommentListService } from './comment-list.service';

export const ngxCommentListServiceModule = angular.module('ngxCommentListServiceModule', [])
	.factory('ngxCommentListService', downgradeInjectable(CommentListService) as any)
	.name;
